<template>
    <SubmenuGrid :items="tools" :show-count="false" />
</template>

<script>
import SubmenuGrid from "@/components/SubmenuGrid";
import tools from "./tools";

export default {
    name: "AcademicManagementSubMenu",
    components: { SubmenuGrid },
    data() {
        return { tools };
    }
};
</script>
